export enum ListLayoutType {
  GRID = 'grid',
  ROW = 'row',
  CAROUSEL = 'carousel'
}
